export const ACCREDITATION_STATUS = {
    FULL_ACCREDITATION: 'Full Accreditation',
    PARTIAL_ACCREDITATION: 'Partial Accreditation',
    NO_ACCREDITATION: 'No Accreditation'
};
